import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import { Col, Row } from 'elements'
import { formSubmit } from 'utils/form'
import { createAntenna, listAllSites, listAllReaders, listAllZones } from 'redux/modules/model/site'
import { listClients } from 'redux/modules/model/client'
import { clientsSelector, allSitesInfoSelector, allReadersInfoSelector, allZonesInfoSelector } from 'redux/selectors'
import { AntennaForm } from 'smart-components'
import { PageContentTitle } from 'components'
import { withClientId } from 'hocs'
import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'operator-invite'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

class AntennaAdd extends Component {
  static propTypes = {
    clientId: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    createAntenna: PropTypes.func.isRequired,
    listClients: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { clientId, listClients, listAllSites, listAllReaders, listAllZones } = this.props
    listClients({ clientId })
    listAllSites({ clientId })
    listAllReaders({ clientId })
    listAllZones({ clientId })
  }

  handleSubmit = (values) => {
    const { clientId, history, createAntenna } = this.props
    return formSubmit(createAntenna, { ...values })
      .then(() => history.push(ROUTES.ANTENNA))
  };

  render() {
    const { clientList, sites, allReadersList, allZonesList } = this.props
    return (
      <Row>
        <Col xs={24} sm={12} md={10}>
          <p className={bemE('back')}><Link to={ROUTES.ANTENNA}>&laquo; Back</Link></p>
          <PageContentTitle>Add a new antenna</PageContentTitle>
          <AntennaForm onSubmit={this.handleSubmit} clients={clientList} sites={sites}
            readers={allReadersList} zones={allZonesList} />
        </Col>
      </Row>
    )
  }
}

export const selector = createStructuredSelector({
  clientList: clientsSelector,
  sites: allSitesInfoSelector,
  allReadersList: allReadersInfoSelector,
  allZonesList: allZonesInfoSelector
})

export const actions = {
  createAntenna,
  listClients,
  listAllSites,
  listAllReaders,
  listAllZones
}

export default compose(
  withRouter,
  withClientId,
  connect(selector, actions),
)(AntennaAdd)



// WEBPACK FOOTER //
// ./src/pages/antenna/antenna-add/index.js